module.exports = __webpack_public_path__ + "img/flag-france.c34081c8.png";